import axiosInstance from "./axiosInstanceV1";

/**
 * Membership API functions for BodhiStreams
 */

/**
 * Fetch all available memberships
 * @returns {Promise<Array>} Array of memberships
 */
export const fetchMemberships = async () => {
	const response = await axiosInstance.get("/public/memberships");
	return response.data;
};

/**
 * Fetch membership by ID
 * @param {string|number} id - Membership ID
 * @returns {Promise<Object>} Membership data
 */
export const fetchMembershipById = async (id) => {
	const response = await axiosInstance.get(`/user/memberships/${id}`);
	return response.data;
};

/**
 * Fetch membership by name (e.g., "Free")
 * @param {string} name - Membership name
 * @returns {Promise<Array>} Array of memberships matching the name
 */
export const fetchMembershipByName = async (name) => {
	const response = await axiosInstance.get(
		`/public/memberships?name=${encodeURIComponent(name)}`,
	);
	return response.data;
};

/**
 * Create a new membership (admin only)
 * @param {Object} membershipData - Membership data
 * @returns {Promise<Object>} Created membership
 */
export const createMembership = async (membershipData) => {
	const response = await axiosInstance.post(
		"/admin/memberships",
		membershipData,
		{
			headers: {
				"Content-Type": "application/json",
			},
		},
	);
	return response.data;
};

/**
 * Update a membership (admin only)
 * @param {string|number} id - Membership ID
 * @param {Object} membershipData - Membership data to update
 * @returns {Promise<Object>} Updated membership
 */
export const updateMembership = async (id, membershipData) => {
	const response = await axiosInstance.put(
		`/admin/memberships/${id}`,
		membershipData,
		{
			headers: {
				"Content-Type": "application/json",
			},
		},
	);
	return response.data;
};

/**
 * Delete a membership (admin only)
 * @param {string|number} id - Membership ID
 * @returns {Promise<void>}
 */
export const deleteMembership = async (id) => {
	await axiosInstance.delete(`/admin/memberships/${id}`);
};
